module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backlog-tasks"
  }, [_c('div', {
    staticClass: "backlog-tasks-rows"
  }, [(_vm.backlogTasks) ? _vm._l((_vm.backlogTasks), function(board) {
    return _c('div', {
      staticClass: "backlog-tasks-row",
      class: [{
        active: board.active,
        'active-filters': _vm.hasActiveFilters,
        'empty': !board.tasks.length
      }, board.slug]
    }, [_c('div', {
      staticClass: "backlog-tasks-row-header",
      on: {
        "dragover": function($event) {
          board.active = true
        },
        "click": function($event) {
          return _vm.activateBoard(board)
        }
      }
    }, [_c('div', {
      staticClass: "backlog-tasks-row-title"
    }, [_vm._v("\n              " + _vm._s(board.name) + "\n              "), _c('span', {
      staticClass: "backlog-tasks-row-title-counter"
    }, [(board.slug === 'completed') ? [_vm._v("\n                Showing " + _vm._s(board.tasks.length) + " of\n              ")] : (_vm.hasActiveFilters) ? [_vm._v("\n                " + _vm._s(board.tasks.length) + " of\n              ")] : _vm._e(), _vm._v("\n              " + _vm._s(board.count) + "\n            ")], 2)]), _vm._v(" "), _c('div', {
      staticClass: "backlog-tasks-row-arrow"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "chevron-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "backlog-tasks-row-body",
      class: {
        'no-items': !board.tasks.length
      }
    }, [(!board.tasks.length) ? _c('div', {
      staticClass: "no-items-text"
    }, [(_vm.hasActiveFilters) ? [_c('span', [_vm._v("\n                    No items in the list match the filters applied.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-inbox fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "inbox",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0\n                          0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49\n                          48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
      }
    })])])] : [(board.slug !== 'completed') ? [_c('span', [_vm._v("\n                    Drag in here a task from the other lists, start organizing your workspace.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-magic fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "magic",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160\n                          80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432\n                          448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19\n                          0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37\n                          8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
      }
    })])])] : [_c('span', [_vm._v("\n                    Nothing to show here yet. When a task changes the status to 'complete', it will appear here.\n                    "), _c('svg', {
      staticClass: "svg-inline--fa fa-inbox fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "inbox",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0\n                          0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49\n                          48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
      }
    })])])]]], 2) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "backlog-tasks-group",
      attrs: {
        "tag": "ul",
        "draggable": ".task",
        "group": board.slug !== 'completed' ? 'backlogTasks' : 'completedTasks'
      },
      on: {
        "start": function($event) {
          _vm.drag = true
        },
        "end": function($event) {
          _vm.drag = false
        },
        "change": function($event) {
          return _vm.handleChange($event, board)
        }
      },
      model: {
        value: (board.tasks),
        callback: function($$v) {
          _vm.$set(board, "tasks", $$v)
        },
        expression: "board.tasks"
      }
    }, 'draggable', board.slug !== 'completed' ? _vm.dragOptions : _vm.completedDragOptions, false), [_c('transition-group', {
      attrs: {
        "type": "transition",
        "name": !_vm.drag ? 'flip-list' : null
      }
    }, _vm._l((board.tasks), function(task) {
      return _c('li', {
        key: task.id,
        staticClass: "backlog-tasks-group-item task",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.goToTask(task.id)
          },
          "dragstart": function($event) {
            return _vm.draggingItem(true)
          },
          "dragend": function($event) {
            return _vm.draggingItem(false)
          },
          "dragover": function($event) {
            return _vm.itemDragOver($event)
          }
        }
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-data"
      }, [_c('span', {
        staticClass: "backlog-tasks-group-item-key",
        class: {
          'line-through': task.status === 4
        }
      }, [_vm._v("\n                      " + _vm._s(task.key) + "\n                    ")]), _vm._v(" "), _c('span', {
        staticClass: "backlog-tasks-group-item-name"
      }, [_vm._v("\n                      " + _vm._s(task.title) + "\n                    ")]), _vm._v(" "), (board.slug !== 'completed' && task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
        staticClass: "backlog-tasks-group-item-chapter"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-progress"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-image",
        style: ({
          backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
        })
      }), _vm._v(" "), _c('svg', {
        staticClass: "progress",
        attrs: {
          "width": "130",
          "height": "130",
          "viewBox": "0 0 100 100"
        }
      }, [_c('circle', {
        staticClass: "progress_meter",
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
        staticClass: "progress_value",
        class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-chapter-name"
      }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-meta-mobile-chapter"
      }, [(board.slug !== 'completed' && task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
        staticClass: "backlog-tasks-group-item-chapter"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-progress"
      }, [_c('div', {
        staticClass: "backlog-tasks-group-item-chapter-image",
        style: ({
          backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
        })
      }), _vm._v(" "), _c('svg', {
        staticClass: "progress",
        attrs: {
          "width": "130",
          "height": "130",
          "viewBox": "0 0 100 100"
        }
      }, [_c('circle', {
        staticClass: "progress_meter",
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
        staticClass: "progress_value",
        class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
        attrs: {
          "cx": "50",
          "cy": "50",
          "r": "44",
          "stroke-width": "5"
        }
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-chapter-name"
      }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-properties"
      }, [(task.recurrent) ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-property recurrency"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "sync-alt",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                            53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                            94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                            57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                            0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                            162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                            504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
        }
      })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-property mandatory"
      }, [_c('svg', {
        staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "exclamation-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                            111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                            136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                            0-12.356 5.78-11.981 12.654z"
        }
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user-info"
      }, [(board.slug !== 'completed') ? _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user status",
        class: ['status-' + task.status]
      }, [(task.status === 1) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "dot-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
        }
      })])] : (task.status === 2) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-spinner fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "spinner",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        }
      })])] : (task.status === 3) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-eye fa-w-18",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "eye",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 576 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
        }
      })])] : (task.status === 4) ? [_c('svg', {
        staticClass: "svg-inline--fa fa-check-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "far",
          "data-icon": "check-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 512 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
        }
      })])] : _vm._e(), _vm._v(" "), (_vm.getStatusById(task.status)) ? _c('span', {
        staticClass: "status-text"
      }, [_vm._v(_vm._s(_vm.getStatusById(task.status).name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "backlog-tasks-group-item-meta-user user-avatar"
      }, [(_vm.taskAssigneeById(task.assignee)) ? [(_vm.taskAssigneeById(task.assignee).image) ? _c('span', {
        style: ({
          backgroundImage: 'url(\'' + _vm.imageBase + _vm.taskAssigneeById(task.assignee).image + '\')'
        })
      }) : _c('avatar', {
        attrs: {
          "username": _vm.taskAssigneeById(task.assignee).label,
          "size": 32,
          "color": "#ffffff"
        }
      })] : [_c('svg', {
        staticClass: "svg-inline--fa fa-user-circle fa-w-16",
        attrs: {
          "aria-hidden": "true",
          "focusable": "false",
          "data-prefix": "fas",
          "data-icon": "user-circle",
          "role": "img",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 496 512"
        }
      }, [_c('path', {
        attrs: {
          "fill": "currentColor",
          "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
        }
      })])]], 2)])])])
    }), 0)], 1)], 1)])
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-509aa33f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/includes/BacklogTasks.vue
// module id = 994
// module chunks = 0